import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import router from "./router";
import Axios from "axios";
import VueMask from "v-mask";
import "./assets/styles/scrollbar.css";
import "./assets/styles/spacing.css";
import "./assets/styles/icons.css";

import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

const setStatusBar = async () => {
  try {
    const platform = Capacitor.getPlatform();

    if (platform === 'ios') {
      document.body.classList.add('is-ios');
    } else if (platform === 'android') {
      document.body.classList.add('is-android');
    }

    // Só executa em plataformas nativas (Android/iOS), não na web
    if (platform === 'web') {
      return;
    }

    if (platform === 'android') {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#F15A24' });
    }

    await StatusBar.setStyle({ style: Style.Light });
  } catch (err) {
    window.console.warn('StatusBar setup failed:', err);
  }
};

setStatusBar();


Vue.config.productionTip = false;
Vue.prototype.$http = Axios;

const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}

Vue.prototype.$http.defaults.baseURL = "https://api.mylegis.com.br/";
// Vue.prototype.$http.defaults.baseURL = "http://localhost:8055/";
Vue.filter("brdatetime", function (value) {
  if (value) {
    const dt = new Date(value)
    return dt.toLocaleString("pt-br") 
  }
});
Vue.filter("filterStatus",function (v) {
  switch (v) {
    case "published":
      return "Público";
    case "friend":
      return "Amigos";
    case "group":
      return "Grupo";
    case "private":
      return "Privado";
  }
})

Vue.use(VueMask);

Vue.filter("brdate", function (value) {
  if (value) {
    const dt = new Date(value)
    return dt.toLocaleDateString("pt-br") 
  }
});

Vue.filter("filetype", function (value) {
  if (value) {
    return value.split("/")[1].toUpperCase();
  }
});

Vue.filter("filesize", function (bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
})
new Vue({
  store,
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
